import { Environment } from '../types/MainContextType';

// Define environment-specific configurations
export const environmentConfigs = {
  development: {
    region: process.env.REACT_APP_AUTH_REGION,
    userPoolId: process.env.REACT_APP_DEV_SSO_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_DEV_SSO_POOL_APP_CLIENT,
    cookieStorage: {
      domain: process.env.REACT_APP_AUTH_COOKIE_STORAGE_DOMAIN,
      path: "/",
      expires: 365,
      sameSite: "strict",
      secure: true
    },
    authenticationFlowType: "USER_SRP_AUTH"
  },
  staging: {
    region: process.env.REACT_APP_AUTH_REGION,
    userPoolId: process.env.REACT_APP_STAGING_SSO_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_STAGING_SSO_POOL_APP_CLIENT,
    cookieStorage: {
      domain: process.env.REACT_APP_AUTH_COOKIE_STORAGE_DOMAIN,
      path: "/",
      expires: 365,
      sameSite: "strict",
      secure: true
    },
    authenticationFlowType: "USER_SRP_AUTH"
  },
  production: {
    region: process.env.REACT_APP_AUTH_REGION,
    userPoolId: process.env.REACT_APP_PROD_SSO_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_PROD_SSO_POOL_APP_CLIENT,
    cookieStorage: {
      domain: process.env.REACT_APP_AUTH_COOKIE_STORAGE_DOMAIN,
      path: "/",
      expires: 365,
      sameSite: "strict",
      secure: true
    },
    authenticationFlowType: "USER_SRP_AUTH"
  }
};

// Get configuration for a specific environment
export const getAuthConfigForEnvironment = (environment: Environment) => {
  return environmentConfigs[environment];
};
